import {
  LOCALE_LABELS,
  PICKER_LOCALE_IDS,
  normalizePickerLocale,
  type PickerLocaleId,
} from "./locales";
import { useLocale } from "./I18nContext";
import { useT } from "./I18nContext";

export function LanguagePicker({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale } = useLocale();
  const t = useT();
  const pickerLocale = normalizePickerLocale(locale);

  return (
    <label className={`lang-picker${compact ? " lang-picker--compact" : ""}`}>
      <span className="lang-picker__label">{t("language.label")}</span>
      <select
        className="lang-picker__select"
        value={pickerLocale}
        aria-label={t("language.choose")}
        onChange={(e) => setLocale(e.target.value as PickerLocaleId)}
      >
        {PICKER_LOCALE_IDS.map((id) => (
          <option key={id} value={id}>
            {LOCALE_LABELS[id]}
          </option>
        ))}
      </select>
    </label>
  );
}
